import React, { useState, useEffect } from "react";
import useUserInfo from "../../Hooks/useUserInfo";
import { useAudio } from "../../Providers/AudioProvider";
import DoEarn from "./DoEarn";
import "./DoEarn.css";
import { PromoHistoryApi } from "../../apis/user";

function PromoHistory() {
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();
  const [promoHistory, setPromoHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copiedPromoId, setCopiedPromoId] = useState(null);

  useEffect(() => {
    const fetchPromoHistory = async () => {
      try {
        setIsLoading(true);
        const response = await PromoHistoryApi(
          userDetails?.userDetails?.telegramId
        );
        if (response.success) {
          // Handle the specific response format where promo codes are in a promoCodes array
          console.log(response.data.data.promoCodes, "response1234");

          if (
            response.data &&
            response.data.data.promoCodes &&
            Array.isArray(response.data.data.promoCodes)
          ) {
            setPromoHistory(response.data.data.promoCodes);
          } else {
            setPromoHistory([]);
          }
        } else {
          setError(response.error || "Failed to fetch promo history");
          setPromoHistory([]);
        }
      } catch (err) {
        setError("An error occurred while fetching promo history");
        console.error("Error fetching promo history:", err);
        setPromoHistory([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (userDetails?.userDetails?.telegramId) {
      fetchPromoHistory();
    }
  }, [userDetails?.userDetails?.telegramId]);

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: DoEarn,
      currentComponentText: "DoEarn",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleCopyPromoCode = (promoCode, promoId) => {
    playClick();
    navigator.clipboard
      .writeText(promoCode)
      .then(() => {
        setCopiedPromoId(promoId);
        setTimeout(() => {
          setCopiedPromoId(null);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy promo code: ", err);
      });
  };

  return (
    <div className="info-img menupointer">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer", pointerEvents: "all" }}
      />
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column",
          pointerEvents: "all",
          marginTop: "60px",
        }}
      >
        <div className="col-11">
          <h3 className="promo-history-title">Promo Code History</h3>
          <div className="promo-design-container row p-3">
            {isLoading ? (
              <div className="text-center p-3">
                <p style={{ color: "#848484" }}>Loading promo history...</p>
              </div>
            ) : error ? (
              <div className="text-center p-3">
                <p style={{ color: "#ff6b6b" }}>{error}</p>
              </div>
            ) : promoHistory.length === 0 ? (
              <div className="text-center p-3">
                <p style={{ color: "#848484" }}>No promo codes found</p>
              </div>
            ) : (
              promoHistory.map((promo, index) => (
                <div
                  key={promo._id || index}
                  className="promo-code-box"
                  style={{
                    borderBottom:
                      index < promoHistory.length - 1
                        ? "0.5px solid rgb(84 83 83)"
                        : "none",
                    marginBottom: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  <div className="col-2">
                    <img
                      src={
                        promoHistory[index].status
                          ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/tick.svg"
                          : "https://d1ccopf5cw1hft.cloudfront.net/s3data/timer.svg"
                      }
                      alt="tick"
                      className="tick-icon"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://d1ccopf5cw1hft.cloudfront.net/s3data/timer.svg";
                      }}
                    />
                  </div>
                  <div className="col-6 promo-code-box-content">
                    <p style={{ fontSize: "14px", marginBottom: "-5px" }}>
                      {promo.reward} $MEMETV
                    </p>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#848484",
                        marginBottom: "-5px",
                      }}
                    >
                      {promo.promoCode}
                    </span>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#848484",
                        display: "block",
                        marginTop: "-2px",
                      }}
                    >
                      {formatDate(promo.createdAt)}
                    </span>
                  </div>
                  <div className="col-3">
                    {promo.status ? (
                      <button
                        className="promo-submit-claim text-uppercase"
                        disabled={true}
                      >
                        Claimed
                      </button>
                    ) : (
                      <button
                        className="promo-submit-pending text-uppercase"
                        onClick={() =>
                          handleCopyPromoCode(promo.promoCode, promo._id)
                        }
                      >
                        {copiedPromoId === promo._id ? "Copied" : "Copy"}
                      </button>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoHistory;
